import React, {useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, Carousel, Form, Input, message } from 'antd';
import { serverFetch } from '../../server';
import TextArea from 'antd/es/input/TextArea';

const Certificate = ({ item, disabled, setCurrentItem, setCond }) => {
    const user = useSelector((s) => s.user);
    const [loading, setLoading] = useState(true);
    const [form] = Form.useForm();
    const [sale, setSale] = useState();
    const [images, setImages] = useState([]);
    const company = useSelector((s) => s.company);

    useEffect(() => serverFetch('image/cert')
        .then(data => {
            setImages(data);
            if (data && data.length > 0){
                setSale({...sale, imageId: data[0].id})
            }
        })
        .catch(e => console.log(e.UserMessage)), []
    )

    useEffect(() => {
        serverFetch('account/info', { method: 'GET' }, user)
                .then((client) => {

                    serverFetch('image/cert')
                        .then(data => {
                            setImages(data);
                            const imageId = data && data.length > 0 && data[0].id;
                            let totalPrice = item.price;
                            const commission = Math.round(company && company.prcCommission > 0 ? totalPrice*company.prcCommission : 0)/100;
                            totalPrice = totalPrice + commission;
                            const sale = {
                                receiverName: client.fullName, 
                                receiverPhone: client.userLogin,
                                receiverEmail: client.email,
                                receiverSendStatus: 0,
                                productId: item.productId,
                                qty: 1,
                                price: item.price,
                                totalPrice, 
                                commission,
                                imageId
                            };
                            if (!sale.receiverEmail)
                                setCond(false);
                            form.setFieldsValue(sale);
                            setSale(sale);
                            setCurrentItem(sale);
                            setLoading(false);

                        })
                        .catch(e => {
                            console.log(e.UserMessage);
                            setLoading(false);
                        })
                })
                .catch((e) => {
                    message.error('Ошибка получения клиента');
                    setLoading(false);
                })
    }, []);

    const onValuesChange = (value) => {
        const newSale = { ...sale, ...value };
        if (newSale.receiverEmail) setCond(true);
        else setCond(false);
        setSale(newSale);
        setCurrentItem(newSale);
    };

    //console.log(sale);

    return (
        <>
            <div className='catalog-item-price' style={{ marginTop: 16, marginBottom: 16 }}>
                {item.price}
            </div>
            <div>{item && item.description}</div>

            <Form colon={false} form={form} labelCol={{ span: 7 }} wrapperCol={{ span: 17 }} onValuesChange={onValuesChange}>
                <Form.Item label='Комиссия' name='commission' wrapperCol={{span: 6}}>
                    <Input size='middle' name='commission' disabled/>
                </Form.Item>
                <Form.Item label='Стоимость' name='totalPrice' wrapperCol={{span: 6}}>
                    <Input size='middle' name='totalPrice' disabled/>
                </Form.Item>
                <Form.Item label='Получатель' name='receiverName'>
                    <Input size='middle' name='receiverName' disabled={loading}/>
                </Form.Item>
                <Form.Item label='Эл. почта' name='receiverEmail' disabled={loading} required>
                    <Input disabled={disabled} />
                </Form.Item>
                <Form.Item label="Дизайн"><Carousel slidesToShow={1} slidesToScroll={1} arrows dots={false} afterChange={e => onValuesChange({imageId: images[e].id})} adaptiveHeight> 
                    {images.map((g) => {
                        return (
                            <Card
                                className='flexible-card card-shadow'
                                key={g.id}
                                cover={<img alt={g.name} src={`${process.env.REACT_APP_API_BASE_URL}/api/image/${g.id}/${g.fileName}`} style={{ maxHeight: 188 }} />}
                                hoverable={true}
                                loading={loading}
                            />
                        );
                    })}
                </Carousel></Form.Item>
                <Form.Item label="Пожелание" name="Description"><TextArea /></Form.Item>
                <Form.Item label="Подпись" name="signText"><Input /></Form.Item>
                {sale && !sale.receiverEmail && <Form.Item style={{color: "red"}} label=" ">Введите электронную почту</Form.Item>}
            </Form>
        </>
    );
};

export default Certificate;
